export default __webpack_public_path__ + "static/media/2-6-1.16430e4d.jpg";